export default {
  title: 'Allergeenit',
  options: {
    dairy: 'Maitotuotteet/Maito',
    eggs: 'Kananmunat',
    fish: 'Kala',
    gluten: 'Gluteeni',
    mango: 'Mango',
    peanuts: 'Maapähkinät',
    sesame: 'Seesami',
    shellfish: 'Äyriäiset',
    soy: 'Soija',
    tree_nuts: 'Pähkinät (puu)',
    celery: 'Selleri',
    crustaceans: 'Äyriäiset (ravut)',
    lupin: 'Lupiini',
    molluscs: 'Simpukat',
    mustard: 'Sinappi',
    nuts: 'Pähkinät',
    sulphites: 'Sulfiitit',
    almonds: 'Mantelit',
    barley: 'Ohra',
    brazil_nuts: 'Parapähkinät',
    cashew: 'Cashewpähkinät',
    hazelnuts: 'Hasselpähkinät',
    kamut: 'Kamut',
    macadamia: 'Macadamiapähkinät',
    oats: 'Kaura',
    pecan: 'Pekaanipähkinät',
    pistachios: 'Pistaasipähkinät',
    rye: 'Ruis',
    spelt: 'Speltti',
    walnuts: 'Saksanpähkinät',
    wheat: 'Vehnä',
    sugared_drink: 'Sokeroitu juoma',
    lentils: 'Linssit',
    queensland_nuts: 'Queenslandinpähkinät',
  },
};
